import React from 'react';

// Modern Button Component
export function ModernButton({ 
  children, 
  onClick, 
  type = 'button',
  variant = 'primary', 
  size = 'md', 
  disabled = false, 
  icon = null, 
  loading = false,
  className = '',
  gradient = null
}) {
  const baseClasses = 'relative inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 transform active:scale-95 overflow-hidden';
  
  const variants = {
    primary: 'bg-linear-to-r from-blue-600 to-purple-600 text-white hover:from-blue-700 hover:to-purple-700 shadow-lg hover:shadow-xl focus:ring-blue-500',
    secondary: 'bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 border border-slate-300 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-700 shadow-xs hover:shadow-md focus:ring-slate-500',
    success: 'bg-linear-to-r from-emerald-600 to-green-600 text-white hover:from-emerald-700 hover:to-green-700 shadow-lg hover:shadow-xl focus:ring-emerald-500',
    warning: 'bg-linear-to-r from-orange-500 to-red-500 text-white hover:from-orange-600 hover:to-red-600 shadow-lg hover:shadow-xl focus:ring-orange-500',
    error: 'bg-linear-to-r from-red-600 to-red-700 text-white hover:from-red-700 hover:to-red-800 shadow-lg hover:shadow-xl focus:ring-red-500',
    ghost: 'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 focus:ring-slate-500'
  };
  
  const sizes = {
    sm: 'px-3 py-2 text-sm',
    md: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-3 text-base',
    xl: 'px-8 py-4 text-lg'
  };
  
  const disabledClasses = 'opacity-60 cursor-not-allowed transform-none bg-linear-to-r from-slate-400 to-slate-500 text-slate-100 dark:from-slate-600 dark:to-slate-700 dark:text-slate-300 shadow-xs';
  
  const buttonClasses = `
    ${baseClasses} 
    ${disabled ? disabledClasses : variants[variant]} 
    ${sizes[size]} 
    ${className}
  `;
  
  return (
    <button
      type={type}
      onClick={disabled || loading ? undefined : onClick}
      disabled={disabled || loading}
      className={buttonClasses}
    >
      {!loading && (
        <div className="absolute inset-0 bg-linear-to-r from-transparent via-white/10 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-500 transform -skew-x-12 -translate-x-full hover:translate-x-full"></div>
      )}
      
      <div className="relative flex items-center space-x-2">
        {loading ? (
          <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
        ) : icon ? (
          <div className="w-5 h-5">{icon}</div>
        ) : null}
        <span>{loading ? 'Lädt...' : children}</span>
      </div>
    </button>
  );
}
